:host {
  display: flex;
  overflow: hidden;
  min-width: 0;
  height: calc(174px - var(--space-unit) * 2);
  max-height: calc(174px - var(--space-unit) * 2);
  padding: var(--space-unit);
  border: var(--border-size-medium) solid var(--color-surface02);
  border-radius: var(--border-size-large);
  cursor: pointer;
  font-family: var(--font-family-sans);
}

:host(:focus:focus-visible) {
  z-index: 1;
  box-shadow: var(--shadow-focus-primary);
  outline: none;
}

:host(.info-card:focus:focus-visible) {
  z-index: 1;
  box-shadow: var(--shadow-focus-primary);
  outline: none;
}

.info-container {
  display: flex;
  overflow: hidden;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  padding-left: calc(var(--space-unit) * 2);
}

.authors-label {
  overflow: hidden;
  color: var(--color-default-text);
  font-size: var(--font-size-2);
  font-weight: var(--font-rg);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-title {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: var(--font-size-3);
  font-weight: var(--font-bd);
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: 1.5;
  word-break: break-word;
}

.card-subtitle {
  overflow: hidden;
  color: var(--color-default-text);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-subtitle.info-subtitle {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: 1.2;
  white-space: normal;
  word-break: break-word;
}

.tags-container {
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
  margin-top: calc(var(--space-unit) * 2);
  gap: var(--space-unit);
}

.volumes-label {
  display: flex;
  height: auto;
  flex-direction: column;
  margin-top: auto;
  color: var(--color-default-text);
  font-size: var(--font-size-1);
}

:host(.info-card) {
  display: flex;
  height: calc(76px - var(--space-unit) * 2);
  max-height: calc(76px - var(--space-unit) * 2);
}

.info-icon-column {
  display: flex;
  width: 50px;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.info-icon-container {
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  margin-bottom: calc(var(--space-unit) * 3);
  background-color: var(--gray50);
  border-radius: var(--border-size-large);
}

.card-title.info-title {
  display: -webkit-box;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
  max-height: 2.4em;
  margin-top: 0;
  margin-bottom: 4px;
  -webkit-box-orient: vertical;
  font-size: var(--font-size-3);
  font-weight: var(--font-bd);
  -webkit-line-clamp: 1;
  line-clamp: 1;
  line-height: 1.2;
  word-break: break-word;
}

.info-icon {
  width: 18px;
  height: 18px;
  color: var(--color-default-text);
}

@media (max-width: 768px) {
  .card-title {
    display: block;
    overflow: hidden;
    line-height: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
